import styled from 'styled-components'
import media from 'styled-media-query'

export const CartHeader = styled.div`
  padding: 22px 25px;
  border-bottom: 1px solid #f0f2f5;
  background: #fbfbfc;
`

export const CartTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h2 {
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    color: #111827;
    
    span {
      display: block;
      font-size: 14px;
      font-weight: 400;
      color: #6b7280;
      margin-top: 6px;
    }
  }
  
  .close-button {
    background: transparent;
    border: none;
    color: #6b7280;
    font-size: 22px;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
      background: #f0f2f5;
      color: #374151;
    }
    
    ${media.greaterThan('medium')`
      display: none;
    `}
  }
`

export const CurrencySwitcher = styled.div`
  display: flex;
  align-items: center;
`

export const CurrencyButton = styled.button`
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  background: ${props => props.active ? '#0062cc' : '#f0f2f5'};
  color: ${props => props.active ? 'white' : '#4b5563'};
  border: none;
  margin-right: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.active ? '#0051a8' : '#e5e7eb'};
  }
  
  &:last-child {
    margin-right: 0;
  }
`

export const CartBody = styled.div`
  flex: 1;
  padding: 20px 25px;
  overflow-y: auto;
  max-height: calc(100vh - 330px);
  width: 100%;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a1a1a1;
  }
`

export const EmptyCart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  
  svg {
    color: #d1d5db;
    font-size: 64px;
    margin-bottom: 16px;
  }
  
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #374151;
    margin: 0 0 10px 0;
  }
  
  p {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
  }
`

export const CartFooter = styled.div`
  padding: 22px 25px;
  border-top: 1px solid #f0f2f5;
  background: #fbfbfc;
`

export const CartTotal = styled.div`
  margin-bottom: 25px;
`

export const SubtotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  color: #6b7280;
  font-size: 15px;
`

export const DiscountRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  color: #10b981;
  font-size: 15px;
  
  div {
    display: flex;
    align-items: center;
    
    span {
      margin-right: 10px;
    }
  }
`

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-weight: 700;
  font-size: 22px;
  color: #111827;
`

export const CouponLink = styled.button`
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  color: #0062cc;
  font-size: 14px;
  padding: 0;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    color: #0051a8;
    text-decoration: underline;
  }
  
  &.add-coupon {
    svg {
      margin-right: 8px;
      font-size: 16px;
    }
  }
`

export const PaymentMethodSelector = styled.div`
  margin: 28px 0;
  
  h4 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 14px 0;
    color: #111827;
  }
  
  > div {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
`

export const PaymentMethod = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px;
  border-radius: 12px;
  background: ${props => props.active ? 'rgba(0, 98, 204, 0.08)' : 'white'};
  border: 1px solid ${props => props.active ? '#0062cc' : '#e5e7eb'};
  color: ${props => props.active ? '#0062cc' : '#4b5563'};
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  min-width: 130px;
  opacity: ${props => props.disabled ? 0.5 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  
  svg {
    font-size: 26px;
    margin-bottom: 16px;
    display: block;
  }
  
  span {
    font-size: 13px;
    font-weight: 500;
    display: block;
    margin-top: 5px;
    line-height: 1;
  }
  
  &:hover {
    border-color: #0062cc;
    background: ${props => props.active ? 'rgba(0, 98, 204, 0.12)' : 'rgba(0, 98, 204, 0.04)'};
    transform: translateY(-2px);
  }
`

export const CheckoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 15px;
  background: #0062cc;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  svg {
    margin-left: 10px;
    font-size: 18px;
  }
  
  &:hover {
    background: #0051a8;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 98, 204, 0.2);
  }
  
  &:disabled {
    background: #d1d5db;
    cursor: not-allowed;
    
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
`
